import { BaseVariableControl } from './_base-control';



export class LabelControl extends BaseVariableControl {
    messages: any = {};
}
